import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-abteilung-notification';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAbteilungNotificationEffects {

    IncidentAbteilungNotification$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_ABTEILUNG_NOTIFICATION),
        mergeMap((x: ac.GetIncidentAbteilungNotificationAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentAbteilungNotification().pipe(
                map((result: any) => {
                    return new ac.GetIncidentAbteilungNotificationErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentAbteilungNotificationFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsTemplatesService);
        }
        return this.service;
    }
}
